import { Box } from "@mui/material";
import { ClinicTabContent } from "./ClinicTabContent/ClinicTabContent";

export const DoctorManagement = () => {
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ClinicTabContent />
    </Box>
  );
};
